import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DragDropDirective } from './directives/dragdrop/dragdrop.directive';
import { AbbPipe } from './pipes/abbriviate/abb.pipe';
import { HumanizePipe } from './pipes/humanize/humanize.pipe';
import { NumberFormatPipe } from './pipes/negativeNumber/negative-number.pipe';
import { TrustedURLPipe } from './pipes/trustedURL/trusted-urlpipe.pipe';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  exports: []
})
export class ServicesModule {}
